import { useState, useEffect } from 'react';

export default function useDebounce(value, delay = 100) {
  const [payload, setPayload] = useState({ value, isWaiting: false });

  useEffect(() => {
    // if the delay changed but the value did not, do not set isWaiting to true
    setPayload((previous) => {
      try {
        if (JSON.stringify(previous.value) === JSON.stringify(value)) {
          return previous;
        }
      } catch (_) {}

      return {
        value: previous.value,
        isWaiting: previous.value !== value,
      };
    });

    const timeout = setTimeout(() => {
      setPayload((previous) => {
        if (previous.isWaiting === false) {
          return previous;
        }

        return { value, isWaiting: false };
      });
    }, delay);

    return () => clearTimeout(timeout);
  }, [value, delay]);

  return payload;
}
